/**
 * Order-related type and enum re-exports.
 *
 * All types are sourced from the generated @/api/data-contracts.
 * This file additionally provides the getNextAdvanceStatus helper.
 */
export {
    OrderActions,
    OrderFilter,
    OrderStatus,
    type OrderDTO,
    type OrderOverviewRowDTO,
    type OrderSearchParamsDTO,
    type OrderCancellationDTO,
    type OrderDeliveryDateUpdateDTO,
    type OrderStatusUpdateDTO
} from "@/api/data-contracts";

import {OrderStatus} from "@/api/data-contracts";

/**
 * Returns the next non-cancellation status in the supplier's advance chain,
 * or undefined if no forward transition exists.
 */
export function getNextAdvanceStatus(current: OrderStatus): OrderStatus | undefined {
    switch (current) {
        case OrderStatus.PENDING:
            return OrderStatus.ORDER_CONFIRMED;
        case OrderStatus.ORDER_CONFIRMED:
            return OrderStatus.DELIVERY_DATE_PROPOSED;
        case OrderStatus.DELIVERY_DATE_CONFIRMED:
            return OrderStatus.DELIVERED;
        default:
            return undefined;
    }
}
